import firebase from "firebase/compat/app";
import 'firebase/compat/firestore';


function read_einsicht(email) {
    console.log("FIRESTORE : readEinsicht " + email);
    let res;

    return firebase.firestore()
        .collection('einsicht')
        .doc(email)
        .get()
        .then(function (doc) {
            var data = doc.data();

            if (data) {
                console.error("   Zugriff ok " + JSON.stringify( doc.data()) );
                res = doc.data();
            }
            else {
                console.error("Noch kein Wert angelegt.");
                res = {};
            }
            return res;
        })
        .catch(function (error) {
            // Kann, passieren, wenn wir einen anonymen user haben...
            // odee, dass wir offline sind.
            console.error("   Rekord nicht gefunden ", error);
            return '';
        });


}

function updateEinsicht(email, value) {
    console.log("FIRESTORE : updateEinsicht " + email);
    let res;

    return firebase.firestore()
        .collection('einsicht')
        .doc(email)
        .set({
            "value": value,
            "timestamp": firebase.firestore.FieldValue.serverTimestamp(),
        }, { merge: true })
        .then(function () {
            console.log("   Success : Update fine");
            res = 1;
        })
        .catch(function (error) {
            console.error("   Failure : ", error);
            res = -1;
        });

}


async function get_time() {
    await helper_write_time()
    var x = await helper_read_time();
    return x.timestamp.toDate();
}


function helper_write_time() {
    return firebase.firestore()
        .collection('admin')
        .doc('time')
        .set({ "timestamp": firebase.firestore.FieldValue.serverTimestamp() });
}

function write_mail(to, sub, msg) {
    return firebase.firestore()
        .collection('logging')
        .doc('mails')
        .collection('test')
        .add({
            "timestamp": firebase.firestore.FieldValue.serverTimestamp(),
            "to": to,
            "subject": sub,
            "msg": msg            
        });
}


function helper_read_time() {
    return firebase.firestore()
        .collection('admin')
        .doc('time')
        .get()
        .then(function (doc) {
            return doc.data();
        })
        .catch(function (error) {
            // Kann, passieren, wenn wir einen anonymen user haben...
            // odee, dass wir offline sind.
            console.error("   Zugriffsfehler (Konnte Time nicht lesen) : ", error);
            return '';
        });
}



// reurns the firebase user record or NULL, in case of error
async function readUser(uid) {
    console.log("FIRESTORE : readUser : " + uid);

    let res;

    await firebase.firestore()
        .collection('users')
        .doc(uid)
        .get()
        .then(function (doc) {
            res = doc.data();
            console.log("   FS-Success : " + res.name);
        })
        .catch(function (error) {
            // Kann, passieren, wenn wir einen anonymen user haben...
            console.error("   FS-Failure : ", error);
            res = null;
        });

    return res;
}




async function writeChatMessage(chatId, email, displayName, text) {

    try {

        await firebase.firestore()
            .collection("chatrooms")
            .doc(email)
            .collection('messages')
            .add({
                chatId: chatId,
                sender: email,
                displayname: displayName,
                text: text,
                timestamp: firebase.firestore.FieldValue.serverTimestamp()
            });

        await firebase.firestore()
            .collection("chatrooms")
            .doc(email)
            .set({
                status: 0,  // Means: not yet responded...
                lastAdded: firebase.firestore.FieldValue.serverTimestamp()
            });

        return { code: 1 };

    } catch (e) {

        console.log("Error " + e);
        return { code: -1 };

    }
}





async function readAccessCode(access_list, code) {

    console.log("FIRESTORE : Reading Code :" + code);

    return firebase.firestore()
        .collection("access_lists")
        .doc(access_list)        
        .get()
        .then(function (doc) {
            console.log(doc.data());
            if (doc.data().access_code === code)
                return 1;
            else
                return -1
        })
        .catch(function (error) {
            console.log("    Code konnte nicht gelesen werden; entweder weil Zugriff nicht erlaubt (siehe rules), oder nicht m�glich")
            return -1;
        });

}


export {
    writeChatMessage, 
    write_mail,
    readAccessCode,   
    updateEinsicht,
    read_einsicht,
    get_time,
    readUser
};
